import '../lib/readmore';

$(function () {
    $('.rw-description__content').readmore({
        embedCSS: true,
        moreLink: '<a href="#" class="btn btn--primary--green mt-4">Lees meer</a>',
        lessLink: '<a href="#" class="btn btn--primary--green mt-4" onclick="window.scrollTo(\'.rw-description__content\')">Toon minder</a>',
        collapsedHeight: 285,
    });
    $('.rw-kenmerken__content').readmore({
        embedCSS: true,
        moreLink: '<a href="#" class="btn btn--primary--green mt-4">Meer kenmerken</a>',
        lessLink: '<a href="#" class="btn btn--primary--green mt-4">Toon minder</a>',
        collapsedHeight: 343,
    });
    if (screen.width < 767) {
        $('.rw-search__read-more').readmore({
            embedCSS: true,
            moreLink: '<a href="#" class="btn btn--primary--green mt-4">Meer filters</a>',
            lessLink: '<a href="#" class="btn btn--primary--green mt-4" onclick="window.scrollTo(\'.rw-kenmerken__content\')">Minder filters</a>',
            collapsedHeight: 160,
        });
    }
});
